import { CurriculumProgram } from "./types";

const PROGRAM_LABEL: Record<string, string> = {
  "Data Science": "Veri Bilimi Yolculuğun",
  "Data Analyst": "Veri Analizi Yolculuğun",
  Fullstack: "Fullstack Yolculuğun",
  Frontend: "Frontend Yolculuğun",
};

const TOPIC_LABEL: Record<string, string> = {
  "Data Analytics": "Veri Bilimi",
  "Fullstack Main": "Fullstack",
};

export default function RoadmapHero({ program }: { program: CurriculumProgram }) {
  const title = PROGRAM_LABEL[program.education_type] ?? "Müfredat Yolculuğun";
  const topicLabel = TOPIC_LABEL[program.topic] ?? program.topic;
  return (
    <div className="mb-6 pl-12 lg:pl-0">
      <h1 className="text-xl sm:text-2xl font-semibold">{title} 🚀</h1>
      <p className="text-white/40 text-sm mt-1">
        Programının {program.total_modules} modülünün neresindesin, ne öğrendin, neler seni bekliyor.
      </p>

      <div
        className="mt-4 flex items-center gap-4 p-4 rounded-2xl border border-white/5"
        style={{ background: "linear-gradient(135deg, rgba(0,102,200,0.12), rgba(113,208,0,0.08))" }}
      >
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-wider text-white/40">İlerleme</div>
          <div className="text-2xl font-bold text-myGreen mt-0.5">%{program.progress_pct}</div>
          <div className="mt-2 h-1 bg-white/10 rounded-full overflow-hidden">
            <div
              className="h-full"
              style={{
                width: `${program.progress_pct}%`,
                background: "linear-gradient(90deg, #71D000, #0066C8)",
              }}
            />
          </div>
        </div>
        <div className="text-right text-xs text-white/60 leading-relaxed">
          <div className="text-sm text-white font-semibold">{topicLabel}</div>
          <div>{program.completed_modules} / {program.total_modules} modül</div>
        </div>
      </div>
    </div>
  );
}
